import { AnimatePresence, motion } from "framer-motion";
import MediaSummery from "./MediaSummery";
import { MediaItem } from "./types/dailyTaskRwo";
import MediaCard from "./MediaCard";
import { useState } from "react";
import { VIEW_MEDIA_URL } from "src/redux/api/appConst";
import { getDownloadUrl } from "src/redux/api/_hr.api";
import { MediaViewer } from "./MediaViewer";

type ViewerState =
  | { open: false }
  | { open: true; item: MediaItem; url: string };

interface MediaViewProps {
  media: MediaItem[];
  grouped: { type: MediaItem["type"]; label: string; items: MediaItem[] }[];
  attendanceId: string;
  role: string;
}

const MediaView = ({ media, grouped, attendanceId, role }: MediaViewProps) => {
  const [viewer, setViewer] = useState<ViewerState>({ open: false });

  const handleView = (item: MediaItem) => {
    const url = `${VIEW_MEDIA_URL}/${item.key}`;
    setViewer({ open: true, item, url });
  };

  const handleDownload = async (item: MediaItem) => {
    try {
      const url = await getDownloadUrl(item.key);

      const response = await fetch(url);
      const blob = await response.blob();

      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = item.key.split("__")[1] || "file";
      a.click();

      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const handleViewerDownload = () => {
    if (viewer.open) handleDownload(viewer.item);
  };

  return (
    <>
      <MediaViewer
        state={viewer}
        onClose={() => setViewer({ open: false })}
        onDownload={handleViewerDownload}
      />
      <div className="space-y-6">
        <MediaSummery media={media} />

        <AnimatePresence>
          {grouped.map(({ type, label, items }) => (
            <motion.div key={type} layout>
              <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400 mb-3">
                {label} ({items.length})
              </p>
              <div className="grid grid-cols-5 gap-3">
                <AnimatePresence>
                  {items.map((item) => (
                    <MediaCard
                      key={item.id}
                      item={item}
                      onView={() => handleView(item)}
                      onDownload={() => handleDownload(item)}
                      attendanceId={attendanceId}
                      role={role}
                    />
                  ))}
                </AnimatePresence>
              </div>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </>
  );
};

export default MediaView;
